import { render, staticRenderFns } from "./PartyForm.vue?vue&type=template&id=b0f3117c&scoped=true"
import script from "./PartyForm.vue?vue&type=script&lang=js"
export * from "./PartyForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0f3117c",
  null
  
)

export default component.exports